<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
/*
export default {
  mounted() {
    this.startInactivityTracker();
  },

  beforeUnmount() {
    this.stopInactivityTracker();
  },

  methods: {
    startInactivityTracker() {
      const events = ['mousemove', 'keydown', 'click', 'scroll'];
      events.forEach(event => {
        window.addEventListener(event, this.onUserActivity);
      });
      this.onUserActivity();
    },

    stopInactivityTracker() {
      const events = ['mousemove', 'keydown', 'click', 'scroll'];
      events.forEach(event => {
        window.removeEventListener(event, this.onUserActivity);
      });
    },

    onUserActivity() {
      this.$store.dispatch("auth/handleUserActivity");
    }
  }
};
*/
</script>